import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import styles from '../../assets/provider-tab.module.scss';
import { IProvider } from 'src/types/provider';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import Loader from 'src/components/Loader';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import IncentiveTable from './components/IncentiveTable';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IIncentive } from 'src/types/incentive';
import user from '../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IIncentive>;
    inProgress: boolean;
}
export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}
interface RouteParams {
    id: string;
    tab?: string;
}
export interface OwnProps {
    provider: Partial<IProvider> | null;
}

export interface Props extends StateProps, DispatchProps, OwnProps, RouteComponentProps<RouteParams> {}
const CaseSession: React.FunctionComponent<Props> = (props: Props) => {
    const { getData, provider, data, getDataCsv, inProgress } = props;
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string }>({
        monthStart: moment().startOf('month').format('YYYY-M-D 00:00:00'),
        monthEnd: moment().endOf('month').format('YYYY-M-D 23:59:59'),
    });

    useEffect(() => {
        if (provider && provider.id) {
            getData({
                page: 1,
                filters: {
                    'provider.id': provider.id,
                    'incentiveDate[before]': month.monthEnd,
                    'incentiveDate[after]': month.monthStart,
                    //  'order[seanceDate]': 'asc',
                },
                itemsPerPage: 9000,
            });
        }

        // eslint-disable-next-line
    }, [getData, props.match.params?.tab, month]);

    const onChangeDate = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D 00:00:00');
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D 23:59:59');
        setMonth({
            monthStart,
            monthEnd,
        });
    };
    const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
    const isSupervisor = user.getSupervisor();

    return (
        <div className={classNames(styles.tabWrap, 'tabWrapSession')}>
            <SimpleCalendar
                setDate={(val) => false}
                navigateDate={onChangeDate}
                containerClassName={`onlyHeaderDatepicker`}
                open={'date'}
                view={'month'}
            />
            {!data ? <Loader /> : null}
            {isProvider && !isSupervisor ? null : (
                <div className={'d-flex justify-content-end'}>
                    <button
                        className={'btn btn-outline-info mt-4'}
                        onClick={() => {
                            getDataCsv({
                                page: 1,
                                filters: {
                                    'provider.id': provider?.id,
                                    'incentiveDate[before]': month.monthEnd,
                                    'incentiveDate[after]': month.monthStart,
                                },
                            });
                        }}
                    >
                        Export .csv
                    </button>
                </div>
            )}

            <div className={classNames(styles.tabsSessions)}>
                {inProgress ? <Loader /> : null}
                <IncentiveTable getData={getData} month={month} data={data} provider={provider} />
            </div>
        </div>
    );
};

export default withRouter(CaseSession);
